import React, { useMemo } from "react";

import { styled } from "@mui/material";

import { getMediaQuery } from "../../getMediaQuery";
import { QuantityButtonRenderer } from "../../QuantityButtonsView/types";
import { cls } from "../../util";
import { useQuantityButtonsContext } from "../context/QuantityButtonsContext";

interface QuantityButtonProps {
  className?: string;
  renderButton: QuantityButtonRenderer;
}

export const QuantityButtons = ({
  renderButton,
  className,
}: QuantityButtonProps) => {
  const { widget, quantity } = useQuantityButtonsContext();

  const { buttons } = widget.variables;
  const selected = useMemo(
    () => buttons.findLast((b) => b.quantity <= quantity),
    [buttons, quantity]
  );

  return (
    <Container className={cls("ig-volume-widget-container", className)}>
      {buttons.map((button, index): any =>
        renderButton({ button, selected: selected === button, index })
      )}
    </Container>
  );
};

const Container = styled("div")(() => {
  const { hasMediaQuery, widget } = useQuantityButtonsContext();
  const { device } = widget;

  return {
    ...(hasMediaQuery ? getMediaQuery(widget) : undefined),
    fontFamily: "inherit",
    margin: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "15px 10px",
    flexDirection: "row",
    maxWidth: device === "desktop" ? "350px" : "100%",
  };
});
